

import { FC, PropsWithChildren } from 'react';

import { Box, Card, Divider, Heading, Stack } from "@eneco/sparky";

interface ReadWithActionProps {
  title: string;
}

const ReadWithAction: FC<PropsWithChildren<ReadWithActionProps>> = ({
                                                                            title,
                                                                            children,
                                                                          }) => {
  return <Card>
    <Stack>
      <Box paddingY="5" paddingX="6">
        <Heading as="h3" size="XS">{title}</Heading>
      </Box>
      <Divider/>
      <Box paddingY="6" paddingX="6">
        <Stack direction="column" alignX="start" gap="6">
          {children}
        </Stack>
      </Box>
    </Stack>
  </Card>
}

export default ReadWithAction;
